<section modalContainer invisibleWhitespace>
  <app-modal-header header (close)="close()">주소 검색</app-modal-header>
  <div
    #container
    class="w-full h-screen xl:max-h-[50rem] overflow-hidden"
  ></div>
  <div footer class="p-4">
    <app-button color="white" expand variant="outline" (click)="close()"
      >닫기</app-button
    >
  </div>
</section>
